<template>
<div class="chapter">
<div class="inner_page">
<h3 class="calibre5" id="pgepubid00003">CONTENTS</h3>
<div class="center">
<table cellpadding="1" class="c">
<tbody class="calibre6"><tr class="calibre7">
<td class="calibre8">I.  </td>
<td class="calibre9"><a class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0003">The Dressmaker's Apprentice at Work</a></td>
</tr>
<tr class="calibre7">
<td class="calibre8">II.  </td>
<td class="calibre9"><a class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0004">Ruth Goes to the Shire-Hall</a></td>
</tr>
<tr class="calibre7">
<td class="calibre8">III.  </td>
<td class="calibre9"><a class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0005">Sunday at Mrs Mason's</a></td>
</tr>
<tr class="calibre7">
<td class="calibre8">IV.  </td>
<td class="calibre9"><a class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0006">Treading in Perilous Places</a></td>
</tr>
<tr class="calibre7">
<td class="calibre8">V.  </td>
<td class="calibre9"><a class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0007">In North Wales</a></td>
</tr>
<tr class="calibre7">
<td class="calibre8">VI.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0008" title="Link target outside of Sample">Troubles Gather About Ruth</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">VII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0009" title="Link target outside of Sample">The Crisis—Watching and Waiting</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">VIII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0010" title="Link target outside of Sample">Mrs Bellingham "Does the Thing Handsomely"</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">IX.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0011" title="Link target outside of Sample">The Storm-Spirit Subdued</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">X.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0012" title="Link target outside of Sample">A Note and the Answer</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XI.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0013" title="Link target outside of Sample">Thurstan and Faith Benson</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0014" title="Link target outside of Sample">Losing Sight of the Welsh Mountains</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XIII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0015" title="Link target outside of Sample">The Dissenting Minister's Household</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XIV.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0016" title="Link target outside of Sample">Ruth's First Sunday at Eccleston</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XV.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0017" title="Link target outside of Sample">Mother and Child</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XVI.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0018" title="Link target outside of Sample">Sally Tells of Her Sweethearts,<br class="calibre1"/>
and Discourses on the Duties of Life</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XVII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0019" title="Link target outside of Sample">Leonard's Christening</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XVIII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0020" title="Link target outside of Sample">Ruth Becomes a Governess in<br class="calibre1"/>
Mr Bradshaw's Family</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XIX.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0021" title="Link target outside of Sample">After Five Years</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XX.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0022" title="Link target outside of Sample">Jemima Refuses to Be Managed</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXI.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0023" title="Link target outside of Sample">Mr Farquhar's Attentions Transferred</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0024" title="Link target outside of Sample">The Liberal Candidate and His Precursor</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXIII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0025" title="Link target outside of Sample">Recognition</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXIV.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0026" title="Link target outside of Sample">The Meeting on the Sands</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXV.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0027" title="Link target outside of Sample">Jemima Makes a Discovery</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXVI.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0028" title="Link target outside of Sample">Mr Bradshaw's Virtuous Indignation</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXVII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0029" title="Link target outside of Sample">Preparing to Stand on the Truth</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXVIII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0030" title="Link target outside of Sample">An Understanding Between Lovers</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXIX.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0031" title="Link target outside of Sample">Sally Takes Her Money Out of the Bank</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXX.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0032" title="Link target outside of Sample">The Forged Deed</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXXI.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0033" title="Link target outside of Sample">An Accident to the Dover Coach</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXXII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0034" title="Link target outside of Sample">The Bradshaw Pew Again Occupied</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXXIII.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0035" title="Link target outside of Sample">A Mother to Be Proud Of</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXXIV.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0036" title="Link target outside of Sample">"I Must Go and Nurse Mr Bellingham"</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXXV.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0037" title="Link target outside of Sample">Out of Darkness into Light</span></td>
</tr>
<tr class="calibre7">
<td class="calibre8">XXXVI.  </td>
<td class="calibre9"><span class="pcalibre1 pcalibre2 pcalibre" href="#/Text/Section0038" title="Link target outside of Sample">The End</span></td>
</tr>
</tbody>
</table>
</div>
<div class="center">
<table class="c">
<tbody class="calibre6"><tr class="calibre7">
<td class="calibre9">
<p class="noindent">Drop, drop, slow tears!<br class="calibre1"/>
<span class="ind">And bathe those beauteous feet,</span><br class="calibre1"/>
Which brought from heaven<br class="calibre1"/>
<span class="ind">The news and Prince of peace.</span><br class="calibre1"/>
Cease not, wet eyes,<br class="calibre1"/>
<span class="ind">For mercy to entreat:</span><br class="calibre1"/>
To cry for vengeance<br class="calibre1"/>
<span class="ind">Sin doth never cease.</span><br class="calibre1"/>
In your deep floods<br class="calibre1"/>
<span class="ind">Drown all my faults and fears;</span><br class="calibre1"/>
Nor let His eye<br class="calibre1"/>
<span class="ind">See sin, but through my tears.</span></p>
<p class="jright"><i class="calibre10">Phineas Fletcher</i></p>
</td>
</tr>
</tbody>
</table>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0002.vue?d65bf83c